import normalize from 'json-api-normalizer';

export const hydrateStoreWithData = (initialState) => {
  const storeContainer = document.getElementById('kjb-redux-store-data');
  if (!storeContainer || !storeContainer.textContent) {
    return initialState;
  }

  let jsonData = {};
  try {
    jsonData = JSON.parse(storeContainer.textContent);
  } catch (err) {
    // no-op
  }

  return { ...initialState, ...normalize(jsonData) }; // hydrate a store
};

// Does not normalize data
export const hydrateStoreDirectlyWithData = (initialState) => {
  const storeContainer = document.getElementById('kjb-redux-store-data');
  if (!storeContainer || !storeContainer.textContent) {
    return initialState;
  }

  let jsonData = {};
  try {
    jsonData = JSON.parse(storeContainer.textContent);
  } catch (err) {
    // no-op
  }

  return { ...initialState, ...jsonData }; // hydrate a store
};
